import { IBaseModel, BaseModel } from '../base.model';
import { IUserDetails } from '../user';
import { TicketTypes } from '../../common/enums';
import { DateTimeHelper } from '../../utils/DateTimeHelper.util';

export interface ITicketListingViewModel extends IBaseModel {
  ticket_number?: number;
  agency?: IUserDetails;
  apartment?: any;
  block?: any;
  caretakers?: any;
  channels?: any;
  //creator?: any[];
  declarant?: any[];
  fk_ticket_agency?: any;
  fk_ticket_apartment?: any;
  apartments?: any;
  fk_ticket_block?: any;
  fk_ticket_character_problem?: any;
  fk_ticket_character_problem_name?: string;
  fk_character_problem_level_2?: any;
  fk_character_problem_level_2_name?: string;
  independents_contractors_mandate?: any;
  independents_contractors_quote?: any;
  managers?: any;
  managers_assigned?: any;
  nb_reopen?: any;
  origin_demand?: any;
  owners?: any;
  pb_type?: any;
  state?: any;
  subject?: any;
  description?: string;
  tenants?: any;
  tenants_await_join?: any;
  actions?: any;
  appointments?: any[];
  close_ticket_reason_name?: string;
  close_ticket_reason_desc?: string;
  as_actor?: any[];
  equipments?: any[];
  apartment_zone?: any[];
  nb_message_unread?: any;
  apartments_formatted?: string;
  ticket_priority?: any;
  pb_character?: any;
  pb_character_level_2?: any;
  ticket_pb_type?: any;
  fk_ticket_substatus?: number;
  substatus?:any
  ticket_availability_mileage?:{availability?:string,mileage?:number}
}

export class TicketListingViewModel extends BaseModel implements ITicketListingViewModel {
  /**
   *
   */
  agency?: IUserDetails;
  ticket_number?: number;
  apartment?: any;
  actions?: any;
  block?: any;
  caretakers?: any;
  //channels?: any;
  channel_id?:any;
  //creator?: any;
  declarant?: any;
  fk_ticket_agency?: any;
  fk_ticket_apartment?: any;
  apartments?: any;
  fk_ticket_block?: any;
  fk_ticket_character_problem?: any;
  fk_ticket_character_problem_name?: string;
  fk_character_problem_level_2?: any;
  fk_character_problem_level_2_name?: string;
  independents_contractors_mandate?: any;
  independents_contractors_quote?: any;
  managers?: any;
  managers_assigned?: any;
  nb_reopen?: any;
  origin_demand?: any;
  owners?: any;
  pb_type?: any;
  state?: any;
  subject?: any;
  description?: string;
  tenants?: any;
  tenants_await_join?: any;
  appointments?: any[];
  appointment?:any;
  close_ticket_reason_name?: string;
  close_ticket_reason_desc?: string;
  as_actor?: any[];
  equipments?: any[];
  apartment_zone?: any[];
  nb_message_unread?: any;
  apartments_formatted?: string;

  pb_type_code: string;
  pb_type_text: string;
  ticket_priority?: any;
  pb_character?: any;
  pb_character_level_2?: any;
  ticket_pb_type?: any;

  ticket_number_formatted : string;
  fk_ticket_substatus?: number;
  substatus?:any
  ticket_availability_mileage?:{availability?:string,mileage?:number}

  get mantenanceDate(): string {
    if (this.appointments && this.appointments.length > 0) {
      const actions = this.appointments[0].actions;
      const appointment = actions[actions.length - 1];

      if (appointment && appointment.appointment_actions) {
        return DateTimeHelper.parseDate(appointment.appointment_actions.appointment.start_date);
      }
      return null//DateTimeHelper.parseDateTime(appointment.appointment_actions.appointment.start_date);
    }
    return null;
  }
  pbTypeText(type: TicketTypes, id: number) {
    let prefix: string;
    if (type === TicketTypes.Private) {
      prefix = '#G-';
    } else if (type === TicketTypes.Public) {
      prefix = '#S-';
    } else {
      prefix = '#I-';
    }
    this.pb_type_code = prefix + id;
  }
  constructor(opt: ITicketListingViewModel) {
    super(opt);
    this.pbTypeText(opt.pb_type, this.ticket_number);
  }
}



// WEBPACK FOOTER //
// ./src/models/ticket/ticket-listing.viewmodel.ts